import { useMemo } from 'react';
import { createPortal } from 'react-dom';

export function Portal({ selector, children }) {
  const root = useMemo(() => document.querySelector(selector), [selector]);

  return root ? createPortal(children, root) : null;
}
